"use client";

import Script from "next/script";
import { BrowserOnly } from "../../../../../components/BrowserOnly";
import { OptimizedImage } from "../../../../../components/OptimizedImage";

export function Donations() {
  return (
    <>
      <div>
        <a
          href="https://ko-fi.com/M4M5KE52Q"
          target="_blank"
          className="flex gap-x-2"
        >
          <OptimizedImage
            src={require("../../../../../images/topher.jpg")}
            alt="Photo of Topher Winward"
            width={36}
            height={36}
            loading="lazy"
            className="bg-green-800 rounded-full"
          />

          <img
            height="36"
            style={{ border: "0px", height: "36px" }}
            src="https://storage.ko-fi.com/cdn/kofi2.png?v=3"
            alt="Buy Me a Coffee at ko-fi.com"
          />
        </a>
      </div>
      <BrowserOnly>
        <Script
          src="https://storage.ko-fi.com/cdn/scripts/overlay-widget.js"
          onLoad={() => {
            try {
              // @ts-ignore
              const kofi = window.kofiWidgetOverlay;
              kofi.draw("topherwinward", {
                type: "floating-chat",
                "floating-chat.donateButton.text": "Support Me",
                // 'floating-chat.donateButton.background-color': '#ff38b8',
                "floating-chat.donateButton.background-color":
                  "rgb(246, 135, 179)",
                "floating-chat.donateButton.text-color": "#fff",
              });
            } catch (e) {
              console.warn("Kofi failed to load", e);
            }
          }}
        />
      </BrowserOnly>
    </>
  );
}
